/**
 * RedigerSak - Rediger eksisterende sak
 */

import React, { useState, useEffect } from 'react';
import crmApi from '../api/crm';
import './NySak.css'; // Bruker samme styling som NySak

export default function RedigerSak({ navigerTil, sakId }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [sak, setSak] = useState(null);

  const [formData, setFormData] = useState({
    klient_id: '',
    saksnummer: '',
    tittel: '',
    sakstype: 'avhendingsloven',
    status: 'aktiv',
    prioritet: 'normal',
    saksbeskrivelse: '',
    motpart_navn: '',
    motpart_org_nr: '',
    er_forsikringssak: false,
    forsikringsselskap: '',
    skadenummer: '',
    klient_har_rettshjelp: false,
    rettshjelp_selskap: '',
    motpart_er_forsikret: false,
    overtakelsesdato: '',
    mangel_oppdaget_dato: '',
    avsluttet_dato: '',
    timesats: '',
    tripletex_prosjektnummer: '',
    tripletex_kundenummer: '',
    // Rettshjelp BKF
    rettshjelp_bkf_selskap_id: '',
    rettshjelp_bkf_selskap_navn: '',
    rettshjelp_bkf_polisenummer: '',
    rettshjelp_bkf_timesats: '',
    rettshjelp_bkf_tillegg: '',
    rettshjelp_bkf_maks_belop: '',
    // Rettshjelp Innbo
    rettshjelp_innbo_selskap_id: '',
    rettshjelp_innbo_selskap_navn: '',
    rettshjelp_innbo_polisenummer: '',
    rettshjelp_innbo_dekningsgrad: '',
    rettshjelp_innbo_maks_belop: '',
    rettshjelp_innbo_aktiveringsgebyr: ''
  });

  useEffect(() => {
    lastSak();
  }, [sakId]);

  const lastSak = async () => {
    try {
      setLoading(true);
      const data = await crmApi.getSak(sakId);
      const sakData = data.sak || data;

      setSak(sakData);

      // Fyll ut skjema med eksisterende data
      setFormData({
        klient_id: sakData.klient_id || '',
        saksnummer: sakData.saksnummer || '',
        tittel: sakData.tittel || '',
        sakstype: sakData.sakstype || 'avhendingsloven',
        status: sakData.status || 'aktiv',
        prioritet: sakData.prioritet || 'normal',
        saksbeskrivelse: sakData.beskrivelse || '',
        motpart_navn: sakData.motpart_navn || '',
        motpart_org_nr: sakData.motpart_org_nr || '',
        er_forsikringssak: sakData.er_forsikringssak || false,
        forsikringsselskap: sakData.forsikringsselskap || '',
        skadenummer: sakData.skadenummer || '',
        klient_har_rettshjelp: sakData.klient_har_rettshjelp || false,
        rettshjelp_selskap: sakData.rettshjelp_selskap || '',
        motpart_er_forsikret: sakData.motpart_er_forsikret || false,
        overtakelsesdato: sakData.overtakelsesdato?.split('T')[0] || '',
        mangel_oppdaget_dato: sakData.mangel_oppdaget_dato?.split('T')[0] || '',
        avsluttet_dato: sakData.avsluttet_dato?.split('T')[0] || '',
        timesats: sakData.timesats || '',
        tripletex_prosjektnummer: sakData.tripletex_prosjektnummer || '',
        tripletex_kundenummer: sakData.tripletex_kundenummer || '',
        rettshjelp_bkf_selskap_id: sakData.rettshjelp_bkf_selskap_id || '',
        rettshjelp_bkf_selskap_navn: sakData.rettshjelp_bkf_selskap_navn || '',
        rettshjelp_bkf_polisenummer: sakData.rettshjelp_bkf_polisenummer || '',
        rettshjelp_bkf_timesats: sakData.rettshjelp_bkf_timesats || '',
        rettshjelp_bkf_tillegg: sakData.rettshjelp_bkf_tillegg || '',
        rettshjelp_bkf_maks_belop: sakData.rettshjelp_bkf_maks_belop || '',
        rettshjelp_innbo_selskap_id: sakData.rettshjelp_innbo_selskap_id || '',
        rettshjelp_innbo_selskap_navn: sakData.rettshjelp_innbo_selskap_navn || '',
        rettshjelp_innbo_polisenummer: sakData.rettshjelp_innbo_polisenummer || '',
        rettshjelp_innbo_dekningsgrad: sakData.rettshjelp_innbo_dekningsgrad || '',
        rettshjelp_innbo_maks_belop: sakData.rettshjelp_innbo_maks_belop || '',
        rettshjelp_innbo_aktiveringsgebyr: sakData.rettshjelp_innbo_aktiveringsgebyr || ''
      });
    } catch (error) {
      console.error('Feil ved lasting av sak:', error);
      alert('Kunne ikke laste sak');
      handleAvbryt();
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.saksnummer || !formData.tittel) {
      alert('Saksnummer og tittel er påkrevd');
      return;
    }

    setSaving(true);

    try {
      await crmApi.updateSak(sakId, formData);
      alert('✅ Sak oppdatert!');

      // Naviger tilbake til saksdetaljer
      if (navigerTil) {
        navigerTil('sak-detaljer', sakId);
      } else {
        window.location.href = `/saker/${sakId}`;
      }
    } catch (error) {
      console.error('Feil ved oppdatering:', error);
      alert('Kunne ikke oppdatere sak: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  const handleAvbryt = () => {
    if (navigerTil) {
      navigerTil('sak-detaljer', sakId);
    } else {
      window.location.href = `/saker/${sakId}`;
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  if (loading) {
    return (
      <div className="ny-sak">
        <div style={{ textAlign: 'center', padding: '48px' }}>
          <div className="spinner"></div>
          <p>Laster sak...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ny-sak">
      <div className="ny-sak-header">
        <h1>✏️ Rediger sak</h1>
        <button className="btn-secondary" onClick={handleAvbryt}>
          ← Tilbake til sak
        </button>
      </div>

      <form onSubmit={handleSubmit} className="ny-sak-form">
        {/* Grunnleggende informasjon */}
        <section className="form-section">
          <h2>Grunnleggende informasjon</h2>

          <div className="form-group">
            <label>Klient</label>
            <input
              type="text"
              value={sak?.klient_navn || ''}
              disabled
              style={{ background: '#f3f4f6', cursor: 'not-allowed' }}
            />
            <p className="form-hint">
              ℹ️ Klient kan ikke endres. Opprett ny sak for annen klient.
            </p>
          </div>

          <div className="form-row">
            <div className="form-group required">
              <label>Saksnummer *</label>
              <input
                type="text"
                value={formData.saksnummer}
                onChange={(e) => handleInputChange('saksnummer', e.target.value)}
                required
              />
            </div>

            <div className="form-group required">
              <label>Sakstype *</label>
              <select
                value={formData.sakstype}
                onChange={(e) => handleInputChange('sakstype', e.target.value)}
                required
              >
                <option value="avhendingsloven">Avhendingsloven</option>
                <option value="bustadoppføringslova">Bustadoppføringslova</option>
                <option value="entreprise">Entreprise</option>
                <option value="eiendomsmegling">Eiendomsmegling</option>
                <option value="naboforhold">Naboforhold</option>
                <option value="annet">Annet</option>
              </select>
            </div>
          </div>

          <div className="form-group required">
            <label>Sakstittel *</label>
            <input
              type="text"
              value={formData.tittel}
              onChange={(e) => handleInputChange('tittel', e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Saksbeskrivelse</label>
            <textarea
              value={formData.saksbeskrivelse}
              onChange={(e) => handleInputChange('saksbeskrivelse', e.target.value)}
              rows="4"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Status</label>
              <select
                value={formData.status}
                onChange={(e) => handleInputChange('status', e.target.value)}
              >
                <option value="aktiv">Aktiv</option>
                <option value="venter">Venter på svar</option>
                <option value="trukket">Trukket</option>
                <option value="avsluttet">Avsluttet</option>
                <option value="arkivert">Arkivert</option>
              </select>
            </div>

            <div className="form-group">
              <label>Prioritet</label>
              <select
                value={formData.prioritet}
                onChange={(e) => handleInputChange('prioritet', e.target.value)}
              >
                <option value="lav">Lav</option>
                <option value="normal">Normal</option>
                <option value="høy">Høy</option>
                <option value="kritisk">Kritisk</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Timesats (kr)</label>
              <input
                type="number"
                value={formData.timesats}
                onChange={(e) => handleInputChange('timesats', e.target.value)}
                placeholder="1500"
              />
            </div>

            {formData.status === 'avsluttet' && (
              <div className="form-group">
                <label>Avsluttet dato</label>
                <input
                  type="date"
                  value={formData.avsluttet_dato}
                  onChange={(e) => handleInputChange('avsluttet_dato', e.target.value)}
                />
              </div>
            )}
          </div>
        </section>

        {/* Motpart */}
        <section className="form-section">
          <h2>Motpart</h2>

          <div className="form-row">
            <div className="form-group">
              <label>Motpartens navn</label>
              <input
                type="text"
                value={formData.motpart_navn}
                onChange={(e) => handleInputChange('motpart_navn', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Org.nr / Fødselsnummer</label>
              <input
                type="text"
                value={formData.motpart_org_nr}
                onChange={(e) => handleInputChange('motpart_org_nr', e.target.value)}
              />
            </div>
          </div>

          <div className="form-group checkbox">
            <label>
              <input
                type="checkbox"
                checked={formData.motpart_er_forsikret}
                onChange={(e) => handleInputChange('motpart_er_forsikret', e.target.checked)}
              />
              <span>Motpart er forsikret</span>
            </label>
          </div>
        </section>

        {/* Datoer */}
        <section className="form-section">
          <h2>Viktige datoer</h2>

          <div className="form-row">
            <div className="form-group">
              <label>Overtakelsesdato</label>
              <input
                type="date"
                value={formData.overtakelsesdato}
                onChange={(e) => handleInputChange('overtakelsesdato', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Mangel oppdaget dato</label>
              <input
                type="date"
                value={formData.mangel_oppdaget_dato}
                onChange={(e) => handleInputChange('mangel_oppdaget_dato', e.target.value)}
              />
            </div>
          </div>
        </section>

        {/* Forsikring */}
        <section className="form-section">
          <h2>Forsikring</h2>

          <div className="form-group checkbox">
            <label>
              <input
                type="checkbox"
                checked={formData.er_forsikringssak}
                onChange={(e) => handleInputChange('er_forsikringssak', e.target.checked)}
              />
              <span>Dette er en forsikringssak</span>
            </label>
          </div>

          {formData.er_forsikringssak && (
            <div className="form-row">
              <div className="form-group">
                <label>Forsikringsselskap</label>
                <input
                  type="text"
                  value={formData.forsikringsselskap}
                  onChange={(e) => handleInputChange('forsikringsselskap', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Skadenummer</label>
                <input
                  type="text"
                  value={formData.skadenummer}
                  onChange={(e) => handleInputChange('skadenummer', e.target.value)}
                />
              </div>
            </div>
          )}
        </section>

        {/* Rettshjelp */}
        <section className="form-section">
          <h2>Rettshjelp</h2>

          <div className="form-group checkbox">
            <label>
              <input
                type="checkbox"
                checked={formData.klient_har_rettshjelp}
                onChange={(e) => handleInputChange('klient_har_rettshjelp', e.target.checked)}
              />
              <span>Klient har rettshjelp</span>
            </label>
          </div>

          {formData.klient_har_rettshjelp && (
            <div className="form-group">
              <label>Rettshjelpselskap</label>
              <input
                type="text"
                value={formData.rettshjelp_selskap}
                onChange={(e) => handleInputChange('rettshjelp_selskap', e.target.value)}
              />
            </div>
          )}
        </section>

        {/* Tripletex integrasjon */}
        <section className="form-section">
          <h2>Tripletex integrasjon</h2>

          <div className="form-row">
            <div className="form-group">
              <label>Prosjektnummer</label>
              <input
                type="text"
                value={formData.tripletex_prosjektnummer}
                onChange={(e) => handleInputChange('tripletex_prosjektnummer', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Kundenummer</label>
              <input
                type="text"
                value={formData.tripletex_kundenummer}
                onChange={(e) => handleInputChange('tripletex_kundenummer', e.target.value)}
              />
            </div>
          </div>
        </section>

        {/* Knapper */}
        <div className="form-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={handleAvbryt}
            disabled={saving}
          >
            Avbryt
          </button>
          <button
            type="submit"
            className="btn-primary"
            disabled={saving}
          >
            {saving ? 'Lagrer...' : '💾 Lagre endringer'}
          </button>
        </div>
      </form>
    </div>
  );
}
